/**
 * Stub for @expo/vector-icons on web builds.
 * The real package contains JSX in .js files which breaks Vite/esbuild.
 * Only native (iOS/Android) code uses vector-icons via NativeIcon.tsx.
 */

const placeholder = () => null;

export default placeholder;
export const MaterialCommunityIcons = placeholder;
export const Ionicons = placeholder;
export const FontAwesome = placeholder;
export const FontAwesome5 = placeholder;
export const Feather = placeholder;
export const MaterialIcons = placeholder;
export const AntDesign = placeholder;
export const Entypo = placeholder;
export const EvilIcons = placeholder;
export const Foundation = placeholder;
export const Octicons = placeholder;
export const SimpleLineIcons = placeholder;
export const Zocial = placeholder;
